import script from "./MovesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MovesPage.vue?vue&type=script&setup=true&lang=ts"

import "./MovesPage.vue?vue&type=style&index=0&id=c1f3cafa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1f3cafa"]])

export default __exports__